export const WIDGET_TYPES = {
  AFFORDABILITY: "affordability",
  PAY_LINK: "pay-link",
  PAYMENT_SINGLE: "payment-single",
  CONNECTIONS: "connections",
  STANDARD_FINANCIAL_STATEMENT: "standard-financial-statement",
  COLLECTIONS_LITE: "collections-lite",
  ACCOUNT_INFORMATION: "account-information",
}
